import { combineReducers } from 'redux';

import authReducer from './features/auth/authSlice';
import userProfileReducer from './features/userProfile/userProfileSlice';
import fileNameReducer from './features/PageName/PageName';

const rootReducer = combineReducers({
  auth: authReducer,
  userProfile: userProfileReducer,
  pagename: fileNameReducer,
});

export default rootReducer;
